import { matchesUdsPropertyType, sanitizeCiSearchFilters } from '../../_helpers/ci-search-filters';
import { hasPaidCiAccess, hasPaidPropertyAccess } from '../../_helpers/subscription-access';
import { PropertyTabId } from './view-area/components/property-tabs/property-tabs.component';
import { CommonModule, Location } from '@angular/common';
import { Component, OnInit, OnDestroy, signal, HostListener, ViewChild, ElementRef } from '@angular/core';
import { PropertyService } from '../../_services/properties/property.service';
import { SearchAsideComponent } from './search-aside/search-aside.component';
import { SearchFiltersComponent } from './search-filters/search-filters.component';
import { MobileViewComponent } from './mobile-view/mobile-view.component';
import { FormsModule } from '@angular/forms';
import { SharingdataService } from '../../_services/sharingdata.service';
import { BasicuserviewComponent } from './basicuserview/basicuserview.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewAreaComponent } from './view-area/view-area.component';
import { BasicmobileviewComponent } from './basicmobileview/basicmobileview.component';
import { Subject, catchError, forkJoin, map, of, skip, switchMap, takeUntil } from 'rxjs';
import { AuthService } from '../../_services/auth.service';
// import { SwipeBackDirective } from './../../directives/swipe-back.directive';

@Component({
  selector: 'app-search',
  standalone: true,
  imports: [CommonModule, SearchFiltersComponent, SearchAsideComponent, MobileViewComponent,FormsModule, BasicuserviewComponent, ViewAreaComponent, BasicmobileviewComponent],
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss',
})
export class SearchComponent implements OnInit, OnDestroy {
  searchFilters = {
    location: '',
    propertyType: 'All', // Apartment, Villa, etc.
    status: 'All',       // Ready to Move, Under Construction
    bhk: 'All',          // 2 BHK, 3 BHK
    minBudget: null,
    maxBudget: null
  };
  @ViewChild('asideWrapper') asideWrapper!: ElementRef;
  propertyList: any = signal([]);
  selectedItem: any = signal<any>(null);
  isMobileView: any = signal(false);
  filteredCount = 0;
  filterDialogOpen = false;
  hasActiveFilters = false;
  isMobile = false;
  carouselPropId:any = null;
  currentTab = 'all-listings';
  propertyDetailTab: PropertyTabId = 'property';
  savedFilterState: any = null;
  savedScrollTop = 0;
  isMobileDetailOpen = false;
  lastSelectedId: string | null = null;
  isLightboxOpen = false;
  activeLightboxIndex = 0;
  

  private touchStartX = 0;
  private touchStartY = 0;
  private touchEndX = 0;
  private touchEndY = 0;

  private isLightboxSwiping = false;

  amenityMap = [
    { key: 'lift', label: 'Lift', icon: 'M8 9l4-4 4 4m0 6l-4 4-4-4' },
    { key: 'gym', label: 'Gym', icon: 'M4 6h16M4 12h16m-7 6h7' },
    { key: 'swimmingPool', label: 'Swimming Pool', icon: 'M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9' },
    { key: 'powerBackup', label: 'Power Backup', icon: 'M13 10V3L4 14h7v7l9-11h-7z' },
    { key: 'security', label: '24/7 Security', icon: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z' },
    { key: 'clubHouse', label: 'Club House', icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6' }
  ];
  furnishingMap = [
    { key: 'wardrobe', label: 'Wardrobe', emoji: '🚪' },
    { key: 'modularKitchen', label: 'Modular Kitchen', emoji: '🍳' },
    { key: 'airConditioner', label: 'Air Conditioner', emoji: '💨' },
    { key: 'chimney', label: 'Chimney', emoji: '🌫️' },
    { key: 'sofa', label: 'Sofa', emoji: '🛋️' },
    { key: 'bed', label: 'Bed', emoji: '🛏️' },
    { key: 'fridge', label: 'Fridge', emoji: '❄️' },
    { key: 'fan', label: 'Exhaust Fan', emoji: '🌀' },
    { key: 'light', label: 'Lights', emoji: '💡' }
  ];
  loggedInUser:any
  filterObject:any
  private readonly destroy$ = new Subject<void>();
  // Every property fetch (filtered search or unfiltered list) goes through this
  // single trigger + switchMap so a slower, stale response can never land after
  // and overwrite a newer one.
  private readonly fetchTrigger$ = new Subject<{ type: 'all' | 'search'; payload?: any; resetFilters?: boolean; propertyId?: string | null }>();
  constructor(private readonly _PS: PropertyService,private _SD: SharingdataService,
    private route : ActivatedRoute, private router :Router, private location: Location,
    private readonly auth: AuthService) {
      const minSwipeDistance = 45;
    }

  ngOnInit(): void {
    this.auth.user$.pipe(takeUntil(this.destroy$)).subscribe(user => {
      this.loggedInUser = user?.data ? user : { data: user };
    });
    if (this.auth.isLoggedIn()) {
      this.auth.getUserProfile().pipe(takeUntil(this.destroy$)).subscribe({
        next: response => {
          const profile = response?.data ?? response;
          if (profile && response?.status !== false) this.auth.updateUserProfile(profile);
        },
        error: () => { /* Keep the current session when profile refresh fails. */ },
      });
    }
    this.checkScreen();
    // The router reuses SearchComponent when browser history changes query params.
    this.route.queryParamMap?.pipe(skip(1), takeUntil(this.destroy$)).subscribe(params => {
      if (!this.isMobile) return;
      const id = params.get('id');
      if (!id) {
        if (this.isMobileDetailOpen) this.closeMobileView(false);
        return;
      }
      const property = (this.propertyList() || []).find((item: any) => item._id === id);
      if (property) this.selectedProperty({ ...property, detailTab: params.get('tab') }, true);
    });

    this.fetchTrigger$
      .pipe(
        switchMap(req => {
          const source$ = req.type === 'search'
            ? this._PS.searchProperty(req.payload)
            : this._PS.getAllProperties();
          const property$ = req.propertyId
            ? this._PS.getPropertieByID(req.propertyId).pipe(catchError(() => of(null)))
            : of(null);
          return forkJoin({ res: source$, property: property$ }).pipe(
            switchMap(({ res, property }: any) => {
              const exact = (res.data || []).filter((item: any) => matchesUdsPropertyType(item, req.payload));
              const hasCiCriteria = req.payload?.ciVerdict?.length || req.payload?.rentalYieldAbove
                || req.payload?.pricedBelowBenchmark || req.payload?.udsSupportAbove;
              const requestedLocations: string[] = (Array.isArray(req.payload?.location) ? req.payload.location : [req.payload?.location]).filter(Boolean);
              if (req.type !== 'search' || (!req.payload?.propertyName && !hasCiCriteria && !requestedLocations.length) || (!exact.length && !requestedLocations.length)) {
                return of({ req, res, property: property?.data });
              }
              const clusters = new Set(exact.map((item: any) => this.clusterKey(item.microMarket?.cluster)).filter(Boolean));
              if (!requestedLocations.length && !clusters.size && !exact.some((item: any) => typeof item.microMarket === 'string' || item.microMarket?._id || item.microMarket?.micromarketName)) {
                return of({ req, res, property: property?.data });
              }
              return this._PS.getAllCluster().pipe(
                switchMap((markets: any) => {
                  const catalog: any[] = Array.isArray(markets) ? markets : markets?.data || [];
                  for (const market of catalog) {
                    if (requestedLocations.some(location => this.clusterKey(location) === this.clusterKey(market.micromarketName) || this.clusterKey(location) === this.clusterKey(market.cluster))) {
                      const cluster = this.clusterKey(market.cluster);
                      if (cluster) clusters.add(cluster);
                    }
                  }
                  const marketFor = (item: any) => catalog.find(market =>
                    (typeof item.microMarket === 'string' && market._id === item.microMarket)
                    || (item.microMarket?._id && market._id === item.microMarket._id)
                    || (item.microMarket?.micromarketName && this.clusterKey(market.micromarketName) === this.clusterKey(item.microMarket.micromarketName)));
                  for (const item of exact) {
                    const cluster = this.clusterKey(marketFor(item)?.cluster);
                    if (cluster) clusters.add(cluster);
                  }
                  const locations = [...new Set(catalog
                    .filter((market: any) => clusters.has(this.clusterKey(market.cluster)))
                    .map((market: any) => market.micromarketName).filter(Boolean))];
                  if (!locations.length) return of({ req, res, property: property?.data });
                  const { propertyName, ...criteria } = req.payload;
                  return this._PS.searchProperty({ ...criteria, location: locations }).pipe(
                    map((nearby: any) => {
                      const seen = new Set(exact.map((item: any) => item._id));
                      const similar = (nearby.data || []).filter((item: any) => {
                        if (!item._id || seen.has(item._id) || !clusters.has(this.clusterKey(marketFor(item)?.cluster ?? item.microMarket?.cluster)) || !matchesUdsPropertyType(item, req.payload)) return false;
                        seen.add(item._id);
                        return true;
                      });
                      return { req, res: { ...res, data: [...exact, ...similar], exactCount: exact.length }, property: property?.data };
                    })
                  );
                }),
                catchError(() => of({ req, res, property: property?.data }))
              );
            })
          );
        }),
        takeUntil(this.destroy$)
      )
      .subscribe(({ req, res, property }) => {
        if (req.type === 'search') {
          const data = res.data?.filter((item: any) => matchesUdsPropertyType(item, req.payload));
          this.applySearchResponse({ ...res, data });
        } else {
          this.applyAllPropertiesResponse(res, req.resetFilters ?? true);
        }
        if (req.propertyId && property?._id === req.propertyId && matchesUdsPropertyType(property, req.payload)) {
          // Deep links can target a property outside the first page of listings.
          const listings = this.propertyList() ?? [];
          const visibleListings = [property, ...listings.filter((item: any) => item._id !== property._id)];
          this.propertyList.set(visibleListings);
          this.selectedProperty({ ...property, propCount: visibleListings.length, selectedPro: 1 }, this.isMobile);
        }
      });

    const params = this.route.snapshot.queryParamMap;
    this.carouselPropId = params.get('id');
    this.propertyDetailTab = params.get('tab') === 'intelligence' ? 'intelligence' : 'property';
    // Older detail links included descriptive metadata that was never a search filter.
    const isLegacyDetailLink = !!this.carouselPropId &&
      ['type', 'address', 'possession'].some(key => params.has(key));
    this.filterObject = {
      propertyType: isLegacyDetailLink ? [] : params.getAll('propertyType'),
      ciVerdict: params.getAll('ciVerdict'),
      rentalYieldAbove: params.get('rentalYieldAbove'),
      pricedBelowBenchmark: params.get('pricedBelowBenchmark'),
      udsSupportAbove: params.get('udsSupportAbove'),
      location: params.getAll('location'),
      unitTypes: params.getAll('unitTypes'),
      tagType: params.getAll('tagType'),
      propertyName: params.getAll('propertyName'),   // returns string[]
      bhk: params.getAll('bhk'),                     // returns string[]
      status: params.getAll('status'),               // returns string[]
      minBudget: params.get('minBudget') ? parseFloat(params.get('minBudget')!) : null,
      maxBudget: params.get('maxBudget') ? parseFloat(params.get('maxBudget')!) : null,
    };

    this.filterObject = sanitizeCiSearchFilters(this.filterObject, this.hasPaidCiAccess);

    if (isLegacyDetailLink) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { propertyType: null, type: null, address: null, possession: null },
        queryParamsHandling: 'merge',
        replaceUrl: true,
      });
    }

    // Decide the ONE initial fetch: a shared/filtered URL runs a search,
    // otherwise load the unfiltered list — never both.
    const hasSharedFilters = Object.values(this.filterObject).some((val: any) =>
      Array.isArray(val) ? val.length > 0 : val !== null && val !== undefined
    );
    if (hasSharedFilters) {
      this.getSearchProperty(this.filterObject, this.carouselPropId);
    } else {
      this.getAllProperty(true, this.carouselPropId);
    }

    // React only to filter changes made AFTER initial load. skip(1) drops the
    // BehaviorSubject's initial replay, which we've already handled above —
    // without this, that replay used to fire a redundant/racing "all properties"
    // call right alongside the initial search call.
    this._SD.currentResults$.pipe(skip(1), takeUntil(this.destroy$)).subscribe(data => {
      if(Object.keys(data).length > 0){
        this.carouselPropId = null;
        this.getSearchProperty(data);
      } else {
        this.hasActiveFilters = false;
        this.filteredCount = 0;
        this.filterObject = null;
        this.savedFilterState = null;
        this.carouselPropId = null;
        this.currentTab = 'all-listings';
        this.selectedItem.set(null);
        this.lastSelectedId = null;
        this.savedScrollTop = 0;
        this.isMobileView.set(false);
        this.isMobileDetailOpen = false;
        if (this.asideWrapper?.nativeElement) {
          this.asideWrapper.nativeElement.scrollTop = 0;
        }
        this._PS.setData(null);
        this.getAllProperty(true);
      }
    })
  }

  get hasPaidCiAccess(): boolean {
    return hasPaidCiAccess(this.loggedInUser);
  }

  get hasPaidPropertyAccess(): boolean {
    return hasPaidPropertyAccess(this.loggedInUser);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getLocalStorageUser() {
    if (typeof window === 'undefined') return null;
    const user = localStorage.getItem('Cirlced_User');
    return user ? JSON.parse(user) : null;
  }

  goToCustomerPreference(): void {
    this.router.navigate(['/customer-preference']);
  }
  

  @HostListener('window:resize')
  checkScreen() {
    if (typeof window === 'undefined') return;
    this.isMobile = window.innerWidth < 768;
  }

  getSearchProperty(searchData: any, propertyId: string | null = null) {
    const payload = sanitizeCiSearchFilters(searchData, this.hasPaidCiAccess);
    this.fetchTrigger$.next({ type: 'search', payload, propertyId });
  }
  propertyCount:any
  getAllProperty(resetFilters = true, propertyId: string | null = null) {
    this.fetchTrigger$.next({ type: 'all', resetFilters, propertyId });
  }

  private clusterKey(value: unknown): string {
    return typeof value === 'string' ? value.replace(/\s*\([^)]*\)/g, '').trim().replace(/\s+/g, ' ').toLowerCase() : '';
  }

  private applySearchResponse(res: any) {
    this.filteredCount = res.exactCount ?? (res.data?.length || 0);

    this.propertyList.set(res.data);
    this._PS.setData(res.meta);
    this.hasActiveFilters = true;
    if (!this.isMobile && res.data?.length) {
      this.selectedProperty({
        ...res.data[0],
        propCount: res.data?.length,
        selectedPro: 1
      });
    } else {
      this.selectedItem.set(null);
    }
  }

  private applyAllPropertiesResponse(res: any, resetFilters: boolean) {
    try {
      if (res.status) {
        if (resetFilters) {
          this.hasActiveFilters = false;  // ← only reset when explicitly told to
        }
        this.propertyList.set(res.data);
        if (!this.isMobile && res.data?.length) {
          if (this.carouselPropId) {
            const property = res.data.find((item: any) => item._id === this.carouselPropId);
            if (property) {
              this.selectedProperty({ ...property, propCount: res.data.length, selectedPro: 1 });
            }
          } else {
            this.propertyCount = res.data?.length;
            this.selectedProperty({...res.data[0], propCount: res.data?.length, selectedPro: 1});
          }
        }
      }
    } catch (error) {}
  }
  selectedProperty(property: any, openMobile = false) {

    // save current scroll position
    if (this.asideWrapper?.nativeElement) {
      this.savedScrollTop =
        this.asideWrapper.nativeElement.scrollTop;
    }

    // save clicked property id
    this.lastSelectedId = property?._id;

    // select property
    this.propertyDetailTab = property?.detailTab === 'intelligence'
      || (this.carouselPropId === property?._id && this.route.snapshot.queryParamMap.get('tab') === 'intelligence')
      ? 'intelligence' : 'property';
    this.selectedItem.set(property);

    // open mobile detail
    if (this.isMobile && openMobile) {
      this.isMobileView.set(true);
      this.isMobileDetailOpen = true;
    }
  }

  closeMobileView(updateUrl = true) {

    if (updateUrl) {
      void this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { id: null, name: null, tab: null },
        queryParamsHandling: 'merge',
        replaceUrl: true,
      });
    }

    this.isMobileView.set(false);
    this.isMobileDetailOpen = false;

    let tries = 0;

    const findCard = () => {

      const card = document.querySelector(
        `[data-id="${this.lastSelectedId}"]`
      ) as HTMLElement;

      if (card) {
        card.scrollIntoView({
          block: 'center',
          behavior: 'smooth'
        });
        return;
      }

      tries++;

      if (tries < 15) {
        setTimeout(findCard, 100);
      }
    };

    setTimeout(findCard, 120);
  }
  // getVisibleAmenities(amenities: any) {
  //   if (!amenities) {
  //     return [];
  //   }
  //   return this.amenityMap.filter(item => {
  //     const val = amenities[item.key];
  //     return val === true || (typeof val === 'string' && val.trim().length > 0);
  //   });
  // }
  getDisplayList(furnishingDetails:any) {
    if (!furnishingDetails) {
      return [];
    }
    return this.furnishingMap
      .filter(item => {
        const val = furnishingDetails[item.key as keyof typeof furnishingDetails];
        return val === true || (typeof val === 'number' && val > 0);
      })
      .map(item => {
        const val = furnishingDetails[item.key as keyof typeof furnishingDetails];
        return {
          emoji: item.emoji,
          // If value is a number > 1, show "3 Air Conditioner", else just "Chimney"
          text: typeof val === 'number' ? `${val} ${item.label}` : item.label
        };
      });
  }
  
  // Add this function inside your class
  formatAddress(item: any): string {
    if (!item) return '';

    return [
      item.name,
      item.address,
      item.streetName,
      item.cityName,
      item.stateName
    ]
    .filter(part => part && part.trim() !== '') // Removes null, undefined, or empty strings
    .join(' '); // Joins them with a single space
  }
  // property.component.ts

  // Helper to get the Min and Max price from your array
  getPriceRange(price?:any) {
    const prices = price ?? this.selectedItem().price; // Access your array
    
    if (!Array.isArray(prices) || prices.length === 0) return null;

    const numericValues = prices.map(p => p.price);
    const min = Math.min(...numericValues);
    const max = Math.max(...numericValues);

    return { min, max, isSame: min === max };
  }

  readonly AMENITY_MAP: Record<string, { label: string, icon: string }> = {
    // Common / General
    air_conditioned: { label: 'AC', icon: 'M13 10V3L4 14h7v7l9-11h-7z' },
    wifi: { label: 'Wi-Fi', icon: 'M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.343 9.257c5.858-5.858 15.355-5.858 21.213 0' },
    power_backup: { label: 'Power Backup', icon: 'M13 10V3L4 14h7v7l9-11h-7z' },
    vaastu: { label: 'Vaastu Compliant', icon: 'M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707' },
    
    // Luxury & Premium
    private_pool: { label: 'Private Pool', icon: 'M21 16v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5m16-4v1M5 12v1m11-1h2m-10 0H7m4-1v2m-1 1h2' },
    sky_villa: { label: 'Sky Villa', icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6' },
    skydeck: { label: 'Skydeck', icon: 'M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z' },
    sea_facing: { label: 'Sea Facing', icon: 'M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z' },
    
    // Leisure & Club
    club_house: { label: 'Club House', icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4' },
    banquet_hall: { label: 'Banquet Hall', icon: 'M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9' },
    cafeteria: { label: 'Cafeteria', icon: 'M3 10h18l-2 4H5l-2-4zm8-6h2V7h-2V4zm0 10h2v6h-2v-6z' },
    bar_lounge: { label: 'Bar & Lounge', icon: 'M10 2l3 9h-6l3-9zm0 18v-2m4 2v-4m-8 4v-6' },

    // Sports & Outdoor
    tennis_courts: { label: 'Tennis Courts', icon: 'M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z' },
    golf_course: { label: 'Golf Course', icon: 'M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5' },
    park: { label: 'Park', icon: 'M5.5 14a2 2 0 012-2 2 2 0 012 2v6h-4v-6zM14.5 10a3 3 0 013-3 3 3 0 013 3v10h-6V10z' },

    // Tech & Security
    smart_home: { label: 'Smart Home', icon: 'M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002-2z' },
    fingerprint_access: { label: 'Fingerprint', icon: 'M12 11V7a4 4 0 018 0v4M5 11h14a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2z' },
    intercom: { label: 'Intercom', icon: 'M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z' },

    // Utilities
    piped_gas: { label: 'Piped Gas', icon: 'M12 21a9.003 9.003 0 008.312-5.551L12 13V3a9 9 0 100 18z' },
    ro_water: { label: 'RO Water', icon: 'M19.428 15.341A8 8 0 114.412 15c.118-.364.418-.7.778-.711 1.05-.033 1.74-.74 1.74-1.487a4.25 4.25 0 00-8.5 0c0 .747.69 1.454 1.74 1.487.36.011.66.347.778.711a8 8 0 1115.357-3.341z' },
    rainwater_harvesting: { label: 'Rainwater', icon: 'M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0a2 2 0 01-2 2H6a2 2 0 01-2-2m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5' }
  };
  getVisibleAmenities(amenitiesObj: any) {
    if (!amenitiesObj) return [];
    
    return Object.keys(amenitiesObj)
      .filter(key => 
        amenitiesObj[key] === true && 
        this.AMENITY_MAP[key] // Only show if we have an icon/label defined
      )
      .map(key => ({
        key,
        ...this.AMENITY_MAP[key]
      }));
  }
  getRoomIcon(room: string): string {
    const icons: { [key: string]: string } = {
      'Servant Room': 'fa-solid fa-user-tie',
      'Study Room': 'fa-solid fa-book-open',
      'Store Room': 'fa-solid fa-boxes-stacked',
      'Media Room': 'fa-solid fa-film',
      'Pooja Room': 'fa-solid fa-om',
      'Guest Room': 'fa-solid fa-bed'
    };
    // Returns the icon class or a default house icon if not found
    return icons[room] || 'fa-solid fa-door-open';
  }
  // goBack() {
  //   this.location.back();
  // }


  openLightbox(index: number): void {

    console.log('SEARCH LIGHTBOX EVENT:', index);

    this.activeLightboxIndex = index;
    this.isLightboxOpen = true;

    console.log('LIGHTBOX OPEN:', this.isLightboxOpen);
    console.log('SELECTED PROPERTY:', this.selectedItem());
    console.log('GALLERY:', this.selectedItemGalleryImages);

    document.body.style.overflow = 'hidden';
  }
  closeLightbox(): void {

    this.isLightboxOpen = false;

    document.body.style.overflow = '';
  }
  previousLightbox(): void {

    const images = this.selectedItemGalleryImages;

    if (!images.length) {
      return;
    }

    this.activeLightboxIndex =
      this.activeLightboxIndex <= 0
        ? images.length - 1
        : this.activeLightboxIndex - 1;
  }
  nextLightbox(): void {

    const images = this.selectedItemGalleryImages;

    if (!images.length) {
      return;
    }

    this.activeLightboxIndex =
      this.activeLightboxIndex >= images.length - 1
        ? 0
        : this.activeLightboxIndex + 1;
  }

  get selectedItemGalleryImages(): any[] {

  const item = this.selectedItem();

  if (!item) {
    return [];
  }

  const images = Array.isArray(item.galleryImage)
    ? item.galleryImage
    : [];

  const videos = Array.isArray(item.propertyVideo)
    ? item.propertyVideo
    : [];

  const combined = [
    ...videos,
    ...images
  ];

  return combined
    .map((media: any) => {

      const url =
        typeof media === 'string'
          ? media
          : media?.videoUrl ||
            media?.src ||
            media?.url;

      if (!url) {
        return null;
      }

      const cleanUrl = url
        .split('?')[0]
        .split('#')[0]
        .toLowerCase();

      const isVideo =
        cleanUrl.endsWith('.mp4') ||
        cleanUrl.endsWith('.webm') ||
        cleanUrl.endsWith('.ogg') ||
        cleanUrl.endsWith('.mov');

      return {
        type: isVideo ? 'video' : 'image',
        src: url,
        thumbnail: isVideo
          ? `${url}#t=0.1`
          : url
      };

    })
    .filter(Boolean);
}

  @HostListener('document:keydown.escape')
  onEscapeLightbox(): void {
    if (this.isLightboxOpen) {
      this.closeLightbox();
    }
  }

  onLightboxTouchStart(event: TouchEvent): void {
    if (!this.isLightboxOpen || !event.touches.length) {
      return;
    }

    this.touchStartX = event.touches[0].clientX;
    this.touchStartY = event.touches[0].clientY;

    this.touchEndX = this.touchStartX;
    this.touchEndY = this.touchStartY;

    this.isLightboxSwiping = false;
  }

  onLightboxTouchMove(event: TouchEvent): void {
    if (!this.isLightboxOpen || !event.touches.length) {
      return;
    }

    this.touchEndX = event.touches[0].clientX;
    this.touchEndY = event.touches[0].clientY;

    const deltaX = this.touchEndX - this.touchStartX;
    const deltaY = this.touchEndY - this.touchStartY;

    // Only treat predominantly horizontal movement as a swipe
    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 20) {
      this.isLightboxSwiping = true;
    }
  }

  onLightboxTouchEnd(): void {
    if (!this.isLightboxOpen) {
      return;
    }

    const deltaX = this.touchEndX - this.touchStartX;
    const deltaY = this.touchEndY - this.touchStartY;

    const minSwipeDistance = 50;

    // Ignore vertical gestures
    if (Math.abs(deltaX) <= Math.abs(deltaY)) {
      this.isLightboxSwiping = false;
      return;
    }

    if (Math.abs(deltaX) < minSwipeDistance) {
      this.isLightboxSwiping = false;
      return;
    }

    if (deltaX < 0) {
      // Swipe LEFT → next image
      this.nextLightbox();
    } else {
      // Swipe RIGHT → previous image
      this.previousLightbox();
    }

    // Prevent the swipe from subsequently triggering the backdrop click
    setTimeout(() => {
      this.isLightboxSwiping = false;
    }, 100);
  }
  handleLightboxBackdropClick(): void {
    if (this.isLightboxSwiping) {
      return;
    }

    this.closeLightbox();
  }

}
